import { V3 } from '../api_request';
import alt, { AltStoreModel, AltActions } from '../alt';

interface State {
  html: string;
}

interface Actions {
  setHTML(html: string);
  fetchHTML(url: string, params: any): any;
  clearHTML();
}

class RailsViewActionsBase extends AltActions implements Actions {
  setHTML(html: string): string {
    return html;
  }

  fetchHTML(url, params) {
    V3.get(url, params).then((resp) => {
      this.setHTML(resp);
    }).fail((_xhr, status, err) => {
      throw new Error(`failed to fetch rails view - status: ${status}, err: ${err}`);
    });

    return null;
  }

  clearHTML() {
    return true;
  }
}

export const RailsViewActions = alt.createActions(RailsViewActionsBase);

class RailsViewStoreBase extends AltStoreModel<State> implements State {
  html = null;

  constructor() {
    super();
    this.bindActions(RailsViewActions);
  }

  onSetHTML(response) {
    this.setState({ html: response });
  }

  onClearHTML() {
    this.setState({ html: null });
  }
}

export const RailsViewStore = alt.createStore(RailsViewStoreBase, 'RailsViewStore');
